<template>
    <div class="tabs-list">
        <a ref="tab" v-for="(item, idx) in items" @click="setActiveTab(idx)">{{ item }}</a>
    </div>
</template>

<script>
    export default {
        props: {
            items: Array,
        },
        emits: ['click'],
        methods: {
            setActiveTab(idx) {
                for (let i = 0; i < this.$refs.tab.length; i++) {
                    const el = this.$refs.tab[i];
                    el.className = ''
                }
                this.$refs.tab[idx].className = 'active'

                this.$emit('click', idx)
            }
        },
        mounted() {
            this.$refs.tab[0].className = 'active'
        }
    }
</script>

<style lang="scss" scoped>
.tabs-list {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    a {
        text-decoration: none;
        color: black;
        font-weight: 700;
        padding: 0.5rem 1rem;
        cursor: pointer;
        border-bottom: 4px solid transparent;

        @media (max-width: 480px) {
            width: 48%;
            font-size: 0.75rem;
            text-align: center;
            padding: 0.5rem;
            border: 2px solid transparent;
        }

        &.active {
            border-bottom: 4px solid #ff144f;

            @media (max-width: 480px) {
                border-bottom: 2px solid #ff144f;
            }
        }
    }
}
</style>